import React from 'react'
import { observer } from 'mobx-react'
import { i18nTranslate } from 'src/utils'
import { Row, Container } from 'react-bootstrap'
// import ReactMarkdown from 'react-markdown'
import { AccordionBlockPDP } from 'src/views/components/AccordionBlockPDP'
import { MarkdownComponent } from 'src/views/components/MarkdownComponent'
import {
  getProductPDPTitle,
  enablePdpRedesign,
  getMedia,
  isYouTubeVideo,
} from 'src/utils/commonUtils'
import './styles.scss'

@observer
class ProductBenefitsandFeatures extends React.Component {
  nameSpace = 'ssr-resource'
  // getBenefitFeatureVideo = (vedioUrl = '') => {
  //   if (vedioUrl != '') {
  //     const regExp =
  //       /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  //     const match = vedioUrl.match(regExp)
  //     let videoId = match?.[2].length === 11 ? match?.[2] : null
  //     if (vedioUrl.match(regExp)) {
  //       return 'https://www.youtube.com/embed/' + videoId
  //     } else {
  //       return vedioUrl
  //     }
  //   }
  // }

  renderTitle = () => {
    const { isAccordionType = false } = this.props
    const benefitsLable = getProductPDPTitle(
      this.props.product?.tempProperties,
      'benefits'
    )
    return (
      <Row
        className={`about-title ${
          isAccordionType ? 'text-uppercase' : 'border-light-grey'
        }  ${enablePdpRedesign() ? 'pdp-redesign-title' : ''}`}
        noGutters>
        {benefitsLable ||
          i18nTranslate('pdp.benefitsTitle', 'Benefits and Key Features', {
            nameSpace: this.nameSpace,
          })}
      </Row>
    )
  }

  renderBenefits = props => {
    const { benefitsListArray, benefitdet, benefits1, Markdown } = props || {}
    // const isHeaderPresent = benefits1?.[0]?.benefits?.startsWith('**')
    return (
      <div>
        <div className="benefits-feature-accordion d-flex flex-wrap align-items-start justify-content-between">
          <div className="benefits-feature-inner">
            {/* {benefitdet && (
              <>
                <Markdown
                  components={{ strong: 'h6' }}
                  className={`${isHeaderPresent ? 'mardown-header' : ''}`}>
                  {benefits1?.[0]?.benefits || ''}
                </Markdown>
              </>
            )} */}
            {benefitsListArray.map((item, index) => {
              const isHeaderPresent = item?.startsWith('**')
              return (
                <span data-testid={`qa-pdp-benefits-point-${index + 1}`}>
                  <Markdown
                    components={{ strong: 'h6' }}
                    className={`${isHeaderPresent ? 'mardown-header' : ''} ${enablePdpRedesign() ? 'pdp-redesign-desc-text' : ''}`}>
                    {item}
                  </Markdown>
                </span>
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const product = this.props?.product || {}
    const benefitdet = product?.benefits || []
    let benefits1
    try {
      benefits1 = [JSON.parse(benefitdet)]
    } catch (e) {
      benefits1 = [[]]
      console.log('Data parse error::: ProductBenefitsandFeatures ' + e)
    }

    let values = Object.values(...benefits1)
    let renderAccordion = values.some(item => (item?.length > 0 ? true : false))

    const { benefits, image, youTubeVideoId } = benefits1[0]
    const benefitsListArray = benefits?.split('\n')

    return (
      <>
        {renderAccordion && (
          <div
            className={`${enablePdpRedesign() ? 'product-accordion-wrapper-pdp' : ''} product-accordion-wrapper`}
            id="benefits">
            <AccordionBlockPDP
              title={this.renderTitle()}
              isDefaultOpen={false}
              className="accordion-description benefits-accordion"
              dataTestId="qa-pdp-benefits">
              <Container className="pdp-accordion-content-container">
                {(youTubeVideoId || image?.url) && (
                  <div className="pdp-videos-benefits">
                    {getMedia({
                      url: image?.url,
                      youTubeVideoId: youTubeVideoId,
                      thumbnail: image?.thumbnail,
                      alt: image?.alt,
                    })}
                  </div>
                )}
                <MarkdownComponent>
                  {({ default: Markdown }) =>
                    this.renderBenefits({
                      benefitsListArray,
                      benefitdet,
                      benefits1,
                      Markdown,
                    })
                  }
                </MarkdownComponent>
              </Container>
            </AccordionBlockPDP>
          </div>
        )}
      </>
    )
  }
}

export { ProductBenefitsandFeatures }
